import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { CheckAvailabilityComponent } from './check-availability.component'
import { AdvancedSearchComponent } from './advanced-search.component';

const routes: Routes = [
  { path: '', component: CheckAvailabilityComponent },
  { path: 'enroll', component: CheckAvailabilityComponent },
  { path: 'enroll/advancedsearch', component: AdvancedSearchComponent },
  // { path: 'check-availability', component: CheckAvailabilityComponent }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CheckAvailabilityRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/check-availability/check-availability-routing.module.ts